import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import IGerencia from "../../../../entities/IGerencia";
import IInspeccionAspectoEvaluar from "../../../../entities/IInspeccionAspectoEvaluar";
import IInspeccionEstadoAspectoEvaluar from "../../../../entities/IInspeccionEstadoAspectoEvaluar";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import ISubContratista from "../../../../entities/ISubContratista";
import IUnidad from "../../../../entities/IUnidad";
import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  APP_ADMIN_MANTENEDOR_IO_ASPECTO_EVALUAR,
  API_ADMIN_MANTENEDOR_IO_ESTADO_ASPECTO_EVALUAR,
  API_ADMIN_GERENCIA,
  API_ADMIN_UNIDAD,
  ROW_COUNT,
  URL_SUPPORT,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import moment from "moment";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import LIOService from "../../../../services/LIOService";
import VppService from "../../../../services/VppService";
import CscService from "../../../../services/CscService";
import CustomToast from "../../../../cross/CustomToast";
import { cParamsActive, cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
import { updateFilter, updateSelectedField } from "../UtilsMantenedor";
import { downloadFile } from "../../../../helpers/fileHelper";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";

const MySwal = withReactContent(Swal);
interface IMantenedorIOAspectosProps {
  items?: Array<any>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciSubgerencia?: Array<IGerencia>;
  cbUnidadProyecto?: Array<IUnidad>;
  cbContratistaSubcontratista?: Array<ISubContratista>;
  cbEstadoAspecto?: Array<IInspeccionEstadoAspectoEvaluar>;
  itemsArrCambiosForm?: Array<IConfirmacionMantenedor>;
  openPopUptest?: boolean;
  is_test?: boolean;
}

const component = (titulo: string) => {
  return <RenderTitle title={titulo} />;
};

const componentValue = (value: any) => {
  return <RenderValue value={value} />;
};

const componentLink = (value: any) => {
  return <RenderLink value={value} />;
};

const RenderValorNuevo = (info: any) => {
  if (info.getValue()?.TIPO == ITipo_Campo.user) {
    return <i>{info.getValue()[`${info.getValue().ID}_DISPLAY`]}</i>;
  } else if (info.getValue()?.TIPO == ITipo_Campo.date) {
    return <i>{shortDate(info.getValue())}</i>;
  } else {
    return <i>{info.getValue()}</i>;
  }
};

const RenderButton = (info: any, token: string, currentUser: any, handleBuscarMA: any) => {
  let desactivar = info.row.original.ACTIVO ? "Desactivar" : "Activar";
  return (
    <button
      className="btnIcono"
      title={desactivar}
      onClick={() => {
        MySwal.fire({
          html: (
            <div>
              <h3>
                ¿Desea {desactivar.toLowerCase()} el registro {info.row.original.CORRELATIVO}?
              </h3>
            </div>
          ),
          text: "",
          icon: "question",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            MySwal.fire({
              html: (
                <div>
                  <h4>Ingrese un Motivo:</h4>
                </div>
              ),
              input: "textarea",
              inputAttributes: {
                autocapitalize: "off",
              },
              showCancelButton: true,
              confirmButtonText: `<i class="bi bi-eye"></i>${desactivar}`,
              cancelButtonText: "Cancelar",
              showLoaderOnConfirm: true,
              preConfirm: async (txtMotivo) => {
                if (!txtMotivo) {
                  Swal.showValidationMessage(`Debe ingresar un motivo`);
                } else {
                  await LIOService.desactivarRegistroLIOAspecto(token, {
                    ID_REGISTRO: info.row.original.ID as number,
                    AUTOR: currentUser?.email as string,
                    AUTOR_DISPLAY: currentUser?.fullname as string,
                    CAMPO: "N/A",
                    EDITOR: currentUser?.email as string,
                    EDITOR_DISPLAY: currentUser?.fullname as string,
                    MODULO: "LIOS",
                    TABLA: "LIO_ASPECTO_EVALUAR",
                    MOTIVO: txtMotivo,
                    VALOR_INICIAL: "N/A",
                    DESACTIVAR: info.row.original.ACTIVO as boolean,
                    FECHA_CREACION: new Date(),
                    FECHA_MODIFICACION: new Date(),
                    VALOR_FINAL: "N/A",
                    ACCION: desactivar.toUpperCase(),
                    CORRELATIVO: info.row.original.CORRELATIVO,
                  });
                  await handleBuscarMA();
                }
              },
              allowOutsideClick: () => !Swal.isLoading(),
            }).then((result) => {
              if (result.isConfirmed) {
                console.log("");
              }
            });
          }
        });
      }}>
      <i className={info.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
    </button>
  );
};

export default function MantenedorIOAspectos({
  is_test,
  items,
  cbVicepresidencia,
  cbGerenciSubgerencia,
  cbUnidadProyecto,
  cbContratistaSubcontratista,
  cbEstadoAspecto,
  itemsArrCambiosForm,
  openPopUptest,
}: IMantenedorIOAspectosProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboVccMA, setComboVcc] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboUPMA, setComboUP] = useState<Array<IUnidad>>(cbUnidadProyecto || []);
  const [comboGSGMA, setComboGSG] = useState<Array<IGerencia>>(cbGerenciSubgerencia || []);
  const [comboCSC, setComboCSC] = useState<Array<ISubContratista>>(cbContratistaSubcontratista || []);
  const [comboEAVMA, setComboEAV] = useState<Array<IInspeccionEstadoAspectoEvaluar>>(cbEstadoAspecto || []);

  const [isEditColum, setIsEditColum] = useState<boolean>(false);
  const [editColumnInfo, setEditColumnInfo] = useState<any>();
  const [listItems, setListItemsMA] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [showToast, setShowToastMA] = useState(false);
  const [hideTable, setHideTable] = useState(true);
  const [arrCambiosForm, setArrCambiosFormMA] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambiosForm || []);
  const [isOpenPopUpGuardarCambios, setIsOpenPopUpGuardarCambiosMA] = useState<boolean>(openPopUptest || false);

  const refTxtCorr = React.createRef<HTMLInputElement>();
  const [refComboVcc, setValComboVccMA] = useState<IComboboxOption | null>(null);
  const [refComboUP, setValComboUPMA] = useState<IComboboxOption | null>(null);
  const [refComboGSG, setValComboGSGMA] = useState<IComboboxOption | null>(null);
  const [refComboCSC, setValComboCSCMA] = useState<IComboboxOption | null>(null);
  const [refcomboEAV, setValComboEAVMA] = useState<IComboboxOption | null>(null);
  const [selectedField, setSelectedField] = useState({} as any);
  const refTxtMotivo = React.createRef<HTMLTextAreaElement>();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [isSendingData, setIsSendingData] = useState(false);

  const columnHelperMantIOAspectos = createColumnHelper<IInspeccionAspectoEvaluar>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();

  const changeField = (id: string, valor: any) => {
    let sf: any = updateSelectedField(id, valor);
    setSelectedField(sf);
  };
  let columnsDef = [
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      title: "Correlativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `LIO."CORRELATIVO"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.ID, {
      id: "DESACTIVAR",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, number>) => RenderButton(info, token, currentUser, handleBuscarMA),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.ASPECTO, {
      id: "ASPECTO",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Aspecto"),
      hide: false,
      title: "Aspecto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"ASPECTO"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.ESTADO_ASPECTO_EVALUAR, {
      id: "ESTADO_COLUMNA",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      hide: false,
      title: "Estado",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"ESTADO_ASPECTO_EVALUAR"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.TITULO, {
      id: "TITULO",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Título"),
      hide: false,
      title: "Título",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `LAE."TITULO"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      hide: false,
      title: "Vicepresidencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"VICEPRESIDENCIA"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      hide: false,
      title: "Gerencia Subgerencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"GERENCIA_SUBGERENCIA"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      hide: false,
      title: "Unidad Proyecto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"UNIDAD_PROYECTO"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.FECHA_INGRESO_ACCION, {
      id: "FECHA_INGRESO_ACCION",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Ingreso"),
      hide: false,
      title: "Fecha Ingreso",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `LAE."FECHA_INGRESO_ACCION"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.RESPONSABLE_ACCION_DISPLAY || rowMA.RESPONSABLE_ACCION, {
      id: "RESPONSABLE_ACCION",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentLink(info.getValue()),
      header: () => component("Responsable"),
      hide: false,
      title: "Responsable",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfo(cell);
        setIsEditColum(true);
        setIsSendingData(false);
      },
      sortId: `LAE."RESPONSABLE_ACCION_DISPLAY"`,
    } as any),
    columnHelperMantIOAspectos.accessor((rowMA) => rowMA.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (info: CellContext<IInspeccionAspectoEvaluar, string>) => componentLink(shortDate(info.getValue())),
      header: () => component("Fecha Hasta"),
      hide: false,
      title: "Fecha Hasta",
      tipo: ITipo_Campo.date,
      onSelectColumn: (cell: any) => {
        setEditColumnInfo(cell);
        setIsEditColum(true);
        setIsSendingData(false);
      },
      sortId: `LAE."FECHA_HASTA"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const comboVccMA = (await VppService.getAll(token, paramsActive)).result.data;
    setComboVcc(comboVccMA);
    const comboCSC = (await CscService.getAll(token, paramsActive)).result.data;
    setComboCSC(comboCSC);
    let comboEAVMA = (
      await getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_IO_ESTADO_ASPECTO_EVALUAR}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
    ).result.data;
    comboEAVMA = comboEAVMA.filter((eae: any) => eae.ID === 3 || eae.ID === 5 || eae.ID === 9);
    setComboEAV(comboEAVMA);
  }, []);

  const exportFileMA = () => {
    const valVcc = refComboVcc?.value;
    const valUP = refComboUP?.value;
    const valGSG = refComboGSG?.value;
    const valCSC = refComboCSC?.value;
    const valEAV = refcomboEAV?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: `LAE."FECHA_INGRESO_ACCION"`,
      ORIENTACION: "DESC NULLS LAST",
      ESTADO_ASPECTO_EVALUAR: valEAV,
      VICEPRESIDENCIA: valVcc,
      GERENCIA_SUBGERENCIA: valGSG,
      UNIDAD_PROYECTO: valUP,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
    };
    getAPI(
      `${URL_SUPPORT}${APP_ADMIN_MANTENEDOR_IO_ASPECTO_EVALUAR}/ExportMantenedorAspectoEvaluar`,
      { Authorization: `Bearer ${token}` },
      params
    ).then((r) => {
      downloadFile(r.result);
    });
  };

  const pagingMA = (page: any) => {
    setPage(page);
    filterMA({ PAGINA: page }, true);
  };

  const filterMA = (filterMA: any, page: boolean = false, size = pageSize) => {
    filterMA = updateFilter(filterMA, size, page);
    setPage(filterMA.PAGINA);

    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVcc?.value;
    const valUP = refComboUP?.value;
    const valGSG = refComboGSG?.value;
    const valCSC = refComboCSC?.value;
    const valEAV = refcomboEAV?.value;
    filterMA.UNIDAD_PROYECTO = valUP;
    filterMA.GERENCIA_SUBGERENCIA = valGSG;
    filterMA.VICEPRESIDENCIA = valVcc;
    filterMA.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filterMA.ESTADO = valEAV;
    filterMA.CORRELATIVO = valCorr;
    filterMA.ORDENADOPOR = `LIO."CORRELATIVO"`;
    filterMA.ORIENTACION = "DESC NULLS LAST";

    getAPI(`${URL_SUPPORT}${APP_ADMIN_MANTENEDOR_IO_ASPECTO_EVALUAR}/getallmantenedor`, { Authorization: `Bearer ${token}` }, filterMA)
      .then((result) => {
        setIsLoading(false);
        setListItemsMA(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const editMA = (value: any, filters: any) => {
    console.log(value);

    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const handleBuscarMA = async () => {
    setIsLoading(true);
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVcc?.value === "Seleccione" ? "" : refComboVcc?.value;
    const valUP = refComboUP?.value === "Seleccione" ? "" : refComboUP?.value;
    const valGSG = refComboGSG?.value === "Seleccione" ? "" : refComboGSG?.value;
    const valCSC = refComboCSC?.value === "Seleccione" ? "" : refComboCSC?.value;
    const valEAV = refcomboEAV?.value === "Seleccione" ? "" : refcomboEAV?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: `LAE."FECHA_INGRESO_ACCION"`,
      ORIENTACION: "DESC NULLS LAST",
      CORRELATIVO: valCorr,
      ESTADO: valEAV,
      VICEPRESIDENCIA: valVcc,
      GERENCIA_SUBGERENCIA: valGSG,
      UNIDAD_PROYECTO: valUP,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      USUARIO: currentUser?.email,
    };
    const result = is_test
      ? { data: [], pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${APP_ADMIN_MANTENEDOR_IO_ASPECTO_EVALUAR}/getallmantenedor`, { Authorization: `Bearer ${token}` }, params))
          .result;
    setArrCambiosFormMA([]);
    let list = result.data;
    setListItemsMA(list);
    let pages = result.pages;
    setPages(pages);
    setHideTable(false);
    setIsLoading(false);
  };

  return (
    <section>
      <div className="rowMA">
        <button
          hidden={true}
          data-testid="test1"
          onClick={() => {
            editMA({ ID: "" }, {});
            exportFileMA();
          }}></button>
        <button
          hidden={true}
          data-testid="test2"
          onClick={() => {
            changeField("1", "1");
            pagingMA(1);
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Inspecciones - Aspectos a evaluar</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="rowMA mb-1 ajusteInput">
                <div className="col-6">
                  <Col>
                    <label>Búsqueda por Correlativo:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorr} className="form-control form-control-sm" />
                  </Col>
                </div>
              </div>
              <div className="rowMA mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Vicepresidencia:</label>
                  <Select
                    options={comboVccMA.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO })) as any}
                    placeholder="Seleccione"
                    value={refComboVcc || ""}
                    isClearable={true}
                    onChange={async (e: any) => {
                      setValComboVccMA(e);
                      let paramsActive = {
                        ...cParamsActive,
                        VICEPRESIDENCIA: e?.value,
                      };
                      if (e?.value) {
                        const comboGSGMA = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;

                        setComboGSG([]);
                        setComboGSG(comboGSGMA);
                        setComboUP([]);
                      } else {
                        setComboGSG([]);
                        setComboUP([]);
                      }
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Gerencia/Subgerencia:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboGSG || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboGSGMA.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboGSGMA(e);
                      let paramsActive = {
                        ...cParamsActive,
                        NOMBRE_GERENCIA_SUBGERENCIA: e?.value,
                      };

                      if (e?.value) {
                        const comboUPMA = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;
                        setComboUP(comboUPMA);
                      } else {
                        setComboUP([]);
                      }
                    }}
                  />
                </Col>
              </div>
              <div className="rowMA mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Unidad Proyecto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboUP || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboUPMA.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboUPMA(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6"></Col>
              </div>
              <div className="rowMA mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Contratista/Subcontratista:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboCSC || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboCSC.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboCSCMA(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Estado Aspecto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refcomboEAV || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboEAVMA.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboEAVMA(e);
                    }}
                  />
                </Col>
              </div>
              <div className="rowMA mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={async () => {
                      handleBuscarMA();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      (refTxtCorr.current as HTMLInputElement).value = "";
                      setValComboVccMA(null);
                      setValComboUPMA(null);
                      setValComboGSGMA(null);
                      setValComboCSCMA(null);
                      setValComboEAVMA(null);
                      setListItemsMA([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  {arrCambiosForm.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambiosMA(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rowMA mb-1">
        <AdminLista
          reload={filterMA}
          items={[]}
          callback={editMA}
          data={listItems}
          tipo={"MantenedorIOAspectos"}
          filter={filterMA}
          pagination={{ pages: pages, page: page, paging: pagingMA }}
          title=""
          hideAdd={true}
          hideExport={true}
          exportar={exportFileMA}
          columnsDef={columnsDef}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filterMA(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>

      {editColumnInfo && (
        <Offcanvas
          show={isEditColum}
          onHide={() => {
            setIsEditColum(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfo.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="rowMA mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>
                {editColumnInfo?.column.columnDef.tipo === ITipo_Campo.date ? (
                  <div>{editColumnInfo && moment(editColumnInfo?.getValue()).format("yyyy-MM-DD")}</div>
                ) : (
                  <div>{editColumnInfo && editColumnInfo?.getValue()}</div>
                )}
              </div>
            </div>
            <div className="rowMA mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      id={editColumnInfo?.column?.id}
                      tipoCampo={editColumnInfo?.column.columnDef.tipo}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>
            <div className="rowMA mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    let jsonMA = selectedField;
                    let arr = arrCambiosForm;
                    jsonMA = {
                      ID: editColumnInfo.row.original.ID,
                      CAMPO_EDITADO: editColumnInfo.column.columnDef.title,
                      CAMPO_EDITADO_ID: editColumnInfo.column.columnDef.id,
                      VALOR_ORIGINAL:
                        editColumnInfo.column.columnDef.tipo === ITipo_Campo.date
                          ? shortDate(editColumnInfo?.getValue(), "yyyy-MM-DD")
                          : editColumnInfo?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfo.column.columnDef.tipo === ITipo_Campo.user ? selectedField : selectedField[editColumnInfo.column.columnDef.id],
                      OBJETO_REF: editColumnInfo.row.original,
                      TIPO: editColumnInfo.column.columnDef.tipo,
                    };
                    if (
                      !isSendingData &&
                      jsonMA.VALOR_ORIGINAL !=
                        (editColumnInfo.column.columnDef.tipo === ITipo_Campo.user
                          ? jsonMA.VALOR_NUEVO[jsonMA.VALOR_NUEVO.ID + "_DISPLAY"]
                          : jsonMA.VALOR_NUEVO)
                    ) {
                      arr.push(jsonMA);
                      setArrCambiosFormMA(arr);
                      setIsEditColum(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColum(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambios && (
        <Offcanvas
          show={isOpenPopUpGuardarCambios}
          onHide={() => {
            setIsOpenPopUpGuardarCambiosMA(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="rowMA mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Inspeccion Aspectos a Evaluar:</span>
            </div>
            <div className="rowMA mb-2">
              <AdminLista
                reload={filterMA}
                items={[]}
                callback={editMA}
                data={arrCambiosForm}
                tipo={"MantenedorIOAspectos"}
                filter={filterMA}
                pagination={{ pages: pages, page: page, paging: pagingMA }}
                title=""
                hideAdd={true}
                hideExport={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((rowMA) => rowMA.ID, {
                    id: "ID",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMA) => rowMA.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMA) => rowMA.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMA) => rowMA.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (info: CellContext<IConfirmacionMantenedor, any>) => RenderValorNuevo(info),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="rowMA mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivo} className="w-100"></textarea>
              </div>
            </div>
            <div className="rowMA mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    if (!refTxtMotivo.current?.value) {
                      refTxtMotivo.current?.classList.add("error");
                      return;
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivo.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      refTxtMotivo.current?.classList.remove("error");
                      if (result.isConfirmed) {
                        let arrIOAspectos: Array<IInspeccionAspectoEvaluar> = [];
                        let arrLogs: Array<ILogMantenedor> = [];

                        arrCambiosForm.forEach((ac) => {
                          if (!arrIOAspectos.find((d) => d.ID === ac.ID)) {
                            arrIOAspectos.push(ac.OBJETO_REF);
                          }
                        });

                        arrIOAspectos.forEach((d: any) => {
                          arrCambiosForm
                            .filter((ac) => ac.ID === d.ID)
                            .forEach((ac) => {
                              let log: ILogMantenedor = {
                                ID: null,
                                MODULO: "LIOS",
                                TABLA: "LIO_ASPECTO_EVALUAR",
                                ID_REGISTRO: d.ID,
                                CAMPO: ac.CAMPO_EDITADO_ID,
                                VALOR_INICIAL: ac.VALOR_ORIGINAL,
                                VALOR_FINAL: null,
                                MOTIVO: refTxtMotivo.current?.value,
                                AUTOR: currentUser?.email,
                                FECHA_CREACION: new Date(),
                                EDITOR: "",
                                FECHA_MODIFICACION: new Date(),
                                AUTOR_DISPLAY: currentUser?.fullname,
                                EDITOR_DISPLAY: "",
                                CORRELATIVO: d.CORRELATIVO,
                              };

                              d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
                              log.VALOR_FINAL = ac.VALOR_NUEVO;
                              if (ac.TIPO === ITipo_Campo.user) {
                                d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
                                d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
                                log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
                              } else if (ac.TIPO === ITipo_Campo.date) {
                                d[ac.CAMPO_EDITADO_ID] = moment(moment(ac.VALOR_NUEVO).format(moment.HTML5_FMT.DATE)).toDate();
                                log.VALOR_FINAL = ac.VALOR_NUEVO;
                              }
                              arrLogs.push(log);
                            });
                        });

                        let value = {
                          LOG_MANTENEDOR: arrLogs,
                          IOASPECTOEVALUAR: arrIOAspectos,
                        };

                        postAPI(`${URL_SUPPORT}${APP_ADMIN_MANTENEDOR_IO_ASPECTO_EVALUAR}/MantenedorIOAE`, value, {
                          Authorization: `Bearer ${token}`,
                        })
                          .then((result) => {
                            if (refTxtMotivo.current) refTxtMotivo.current.value = "";
                            setArrCambiosFormMA([]);
                            let data = result.result.data;
                            console.log(data);
                            let params = { PAGINA: page };
                            filterMA(params);
                          })
                          .catch((error) => {
                            console.log(error);
                          });

                        setIsOpenPopUpGuardarCambiosMA(false);
                        setShowToastMA(true);
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambiosMA(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="rowMA">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
